import type { PlotDataMeta } from './GraphPlotUtil';

export type LegendMeta = Pick<PlotDataMeta, 'name' | 'longLabel' | 'metricTrace'>;

/**
 * Legend text of a trace: the metric's long label, never its unit.
 * @returns `name` is the metric for a metric trace, else the item with the metric as `detail`
 */
export function legendText(meta: LegendMeta | undefined, traceName?: string): { name?: string; detail?: string; } {
  if (!meta) return { name: traceName };
  return meta.metricTrace ? { name: meta.longLabel } : { name: meta.name, detail: meta.longLabel };
}
